import { render } from "./ProductsFilterItem.vue?vue&type=template&id=3dc6b9b2"
import script from "./ProductsFilterItem.vue?vue&type=script&lang=js"
export * from "./ProductsFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/ProductsFilterItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dc6b9b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dc6b9b2', __exports__)) {
    api.reload('3dc6b9b2', __exports__)
  }
  
  module.hot.accept("./ProductsFilterItem.vue?vue&type=template&id=3dc6b9b2", () => {
    api.rerender('3dc6b9b2', render)
  })

}


export default __exports__